angular.module('impactx.approval').controller('ContractChangeAddToRFQHCtrl', ContractChangeAddToRFQHCtrl);

ContractChangeAddToRFQHCtrl.$inject = ['$scope', '$mdDialog', 'TranslationService'];

function ContractChangeAddToRFQHCtrl($scope, $mdDialog, TranslationService) {
    var self = this;

    $scope.trns = {};
    $scope.trns.abort = TranslationService.get('abort');
    $scope.trns.required = TranslationService.get('required');
    $scope.trns.save = self.saveLabel;

    $scope.preparedRFQH = JSON.parse(JSON.stringify(self.preparedRFQH));

    self.cancel = function() {
        $mdDialog.cancel();
    };
    self.answer = function() {
        $mdDialog.hide($scope.preparedRFQH.selected.id);
    };
}